import { render, staticRenderFns } from "./MessageBubble.vue?vue&type=template&id=57fdae0a&scoped=true"
import script from "./MessageBubble.vue?vue&type=script&lang=js"
export * from "./MessageBubble.vue?vue&type=script&lang=js"
import style0 from "./MessageBubble.vue?vue&type=style&index=0&id=57fdae0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fdae0a",
  null
  
)

export default component.exports